import { Device, from } from '@helpers/media';
import { blockquote } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Blockquote = styled.blockquote `
  ${blockquote};

  @media ${from(Device.Tablet)} {
    margin: 0;
  }
`;
const Citation = styled.cite ``;
export const QuoteBlockStyles = {
    Blockquote,
    Citation,
    Container,
};
